<template>
  <div class="modal-content">
    <form novalidate @submit.prevent="login" id="login-modal-form">
      <ErrorMessage
        v-if="errorMessage"
        :error-message="errorMessage"
      ></ErrorMessage>
      <div>
        <Input
          ref="emailInput"
          type="email"
          placeholder="Ваш email*"
          v-model.trim="email"
          :invalid="$v.email.$error"
          @keydown.space.prevent
        />
        <div
          v-if="$v.email.$dirty && !$v.email.required"
          class="invalid-feedback"
        >
          Поле обязательно для заполнения
        </div>
        <div
          v-else-if="$v.email.$dirty && !$v.email.email"
          class="invalid-feedback"
        >
          Некорректный E-mail
        </div>
      </div>

      <div class="form-group-password">
        <Input
          :type="passwordFieldType"
          placeholder="Ваш пароль*"
          v-model.trim="password"
          :invalid="$v.password.$error"
          @keydown.space.prevent
        />
        <button
          class="toggle-password-btn"
          type="button"
          @click="togglePasswordVisibility"
        >
          <span v-if="passwordFieldType === 'password'" key="ico-visibility-off"
            ><ico name="icoVisibilityOff" color="#626262"></ico
          ></span>
          <span v-else key="ico-visibility"
            ><ico name="icoVisibility" color="#626262"></ico
          ></span>
        </button>
        <div
          v-if="$v.password.$dirty && !$v.password.required"
          class="invalid-feedback"
        >
          Поле обязательно для заполнения
        </div>
        <div
          v-else-if="$v.password.$dirty && !$v.password.minLength"
          class="invalid-feedback"
        >
          Пароль должен содержать не менее
          {{ $v.password.$params.minLength.min }} символов
        </div>
      </div>
      <div class="enter-button-wrapper">
        <Button
          variant="gradient"
          type="submit"
          :disabled="isDisabled"
          :title="isDisabled ? 'Заполните обязательные поля' : ''"
          class="button"
        >
          Войти
        </Button>
      </div>
    </form>
  </div>
</template>

<script>
import { email, minLength, required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import ErrorMessage from "@/components/common/ErrorMessage";
import { serviceUnavailable } from "@/utils/constants/errorMessages";
import Input from "@/components/homePage/Input";
import Button from "@/components/homePage/Button";
import mapBX24AuthToPayload from "@/utils/mapBX24AuthToPayload";
import {
  reinitCancelToken,
  source,
} from "@/application/requests/notificationsRequests";

export default {
  name: "BitrixLoginModal",
  data() {
    return {
      email: "",
      password: "",
      passwordFieldType: "password",
      errorMessage: null,
    };
  },
  components: {
    ErrorMessage,
    Input,
    Button,
  },
  validations: {
    email: { required, email },
    password: { required, minLength: minLength(8) },
  },
  computed: {
    ...mapGetters("bitrix", ["isBitrix", "bitrixAuth"]),
    isDisabled: function () {
      return !this.email || !this.password;
    },
  },
  methods: {
    ...mapActions("auth", ["loginUser"]),
    ...mapActions("bitrix", ["linkBitrix"]),
    togglePasswordVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    async login() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      if (!this.isBitrix) {
        this.$toast.error("Перезагрузите страницу");
        this.$modal.container.destroyModal();
        return;
      }

      const credentials = {
        email: this.email,
        password: this.password,
      };
      const payload = mapBX24AuthToPayload(this.bitrixAuth);

      try {
        this.$modal.container.destroyModal();
        await this.loginUser(credentials);
        await this.linkBitrix(payload);
        window.BX24?.installFinish?.();
      } catch (e) {
        const status = e?.response?.status;

        switch (status) {
          case 400:
            this.errorMessage = "Не переданы обязательные данные Bitrix";
            break;

          case 401:
            this.$toast.error("Сессия Bitrix истекла. Перезагрузите страницу");
            break;

          case 409:
            this.$toast.error("Этот портал уже привязан к другому аккаунту");
            break;

          case 502:
            this.$toast.error("Bitrix временно недоступен");
            break;

          default:
            this.$toast.error(e?.message || serviceUnavailable);
        }

        this.logout();
      }
    },
    logout() {
      this.logoutUser();
      this.clearAll();
      localStorage.clear();
      source.cancel();
      reinitCancelToken();
    },
  },
  mounted() {
    this.$refs["emailInput"].focus();
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variables.less";
.modal-content {
  form {
    display: flex;
    flex-direction: column;
    gap: 25px;
    .enter-button-wrapper {
      position: relative;
      width: 100%;
    }
    .button {
      height: 60px;
      font-family: Montserrat;
      font-weight: 600;
      font-size: 24px;
      line-height: 1;
      width: 100%;
    }
  }
}
</style>
